import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Principal } from 'src/app/core/auth/principal.service';

@Directive({
  selector: '[jhiHasAnyAuthorityNoAccess]'
})
export class HasAnyAuthorityNoAccessDirective {

  private perAuthorities: string[];
  private authorities: string[];
  private permissions: string;

  constructor(private principal: Principal, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) { }

  @Input()
  set jhiHasAnyAuthorityNoAccess(perAuthorities: string | string[]) {
    this.perAuthorities = typeof perAuthorities === 'string' ? [perAuthorities] : perAuthorities
    this.permissions = this.perAuthorities[0];
    if (this.perAuthorities && this.perAuthorities.length > 1) {
      this.authorities = typeof perAuthorities === 'string' ? [perAuthorities] : perAuthorities;
    }

    this.updateView();
    // Get notified each time authentication state changes.
    this.principal.getAuthenticationState().subscribe(identity => this.updateView());
  }

  private updateView(): void {
    // let authority = this.principal.authority();

    if (this.authorities && this.permissions) {
      this.principal.hasAnyAuthorityNoAccess(this.authorities, this.permissions).then(result => {
        this.viewContainerRef.clear();
        if (result) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      });
    } else {
      this.principal.hasStaffPermission(this.permissions).then(result => {
        this.viewContainerRef.clear();
        if (result) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      });
    }

  }

}
